export default {
  path: "*",
  name: "Error500",
  component: () => import("@/views/ErrorPages/Error500"),
  meta: {
    middleware_excemption: true
  }
};
